class IconTextBarSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="IconTextBarSlider-"]');
    this.slides = this.querySelectorAll('.icon-text-bar__slide');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.prevButton || !this.nextButton) return;

    this.currentIndex = 0;
    this.autoplay = null;
    this.autoRotate = this.slider.dataset.autoplay === 'true';
    this.speed = (this.slider.dataset.speed || 5) * 1000;

    this.init();
  }

  init() {
    // Show first slide
    this.showSlide(0);

    // Add button event listeners
    this.prevButton.addEventListener('click', () => this.prevSlide());
    this.nextButton.addEventListener('click', () => this.nextSlide());

    // Setup autoplay if enabled
    if (this.autoRotate) {
      this.startAutoplay();

      // Pause on hover/focus
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
    }

    // Handle touch swipe on mobile
    this.setupTouchSwipe();
  }

  showSlide(index) {
    // Hide all slides
    this.slides.forEach((slide, i) => {
      if (i === index) {
        slide.style.display = 'block';
        slide.removeAttribute('tabindex');
        slide.setAttribute('aria-hidden', 'false');
      } else {
        slide.style.display = 'none';
        slide.setAttribute('tabindex', '-1');
        slide.setAttribute('aria-hidden', 'true');
      }
    });

    this.currentIndex = index;

    // Update button states
    this.updateButtons();
  }

  updateButtons() {
    // Enable all buttons by default (for looping)
    this.prevButton.removeAttribute('disabled');
    this.nextButton.removeAttribute('disabled');
  }

  nextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.showSlide(nextIndex);
  }

  prevSlide() {
    const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.showSlide(prevIndex);
  }

  startAutoplay() {
    if (!this.autoRotate || this.slides.length <= 1) return;

    this.stopAutoplay(); // Clear any existing interval
    this.autoplay = setInterval(() => {
      this.nextSlide();
    }, this.speed);
  }

  stopAutoplay() {
    if (this.autoplay) {
      clearInterval(this.autoplay);
      this.autoplay = null;
    }
  }

  setupTouchSwipe() {
    let startX = 0;
    let endX = 0;

    this.slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    this.slider.addEventListener('touchmove', (e) => {
      endX = e.touches[0].clientX;
    }, { passive: true });

    this.slider.addEventListener('touchend', () => {
      const swipeThreshold = 50;
      const diff = startX - endX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swiped left, go to next slide
          this.nextSlide();
        } else {
          // Swiped right, go to previous slide
          this.prevSlide();
        }
      }
    });
  }
}

// Define the custom element for icon-text-bar slider
if (!customElements.get('icon-text-bar-slider')) {
  customElements.define('icon-text-bar-slider', IconTextBarSlider);
}

// Marquee functionality
class IconTextBarMarquee {
  constructor() {
    this.initMarquees();
  }

  initMarquees() {
    const marquees = document.querySelectorAll('.icon-text-bar__marquee-track');

    marquees.forEach((marquee) => {
      const speed = marquee.dataset.speed || 30;
      marquee.style.setProperty('--marquee-speed', `${speed}s`);
    });
  }
}

// Initialize marquee when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new IconTextBarMarquee();
  });
} else {
  new IconTextBarMarquee();
}

// Reinitialize on Shopify theme editor events
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new IconTextBarMarquee();
  });
}
